import {Product} from "../../../shared-gen/Model/Products/Product";
import {getDefaultID} from "../../core";
import { ProductType } from "../../../shared-gen/Model/Products/ProductType";

export class ProductFun {

	static createNew(productID?: string): Product {
		productID = productID || getDefaultID();
		return {
			ID: productID,
			Type: ProductType.Article,
			EanCode: "",
			Name: "",
			OptionChoices: null as any,
			SapNumber: "",
			Sirup: [],
			Vat: 19,
			Price: 0,
			Deposit: 0,
			SelectionNumber: undefined,
			Resources: [],
			Image: null as any,
			Enabled: true
		};
	}

	static getBaseID(productID: string): string {
		if (productID) {
			if (productID.indexOf('-') !== -1) {
				return productID.split('-')[0];
			}
			return productID;
		}
		return '';
	}

}
